"use strict";
/*
 * Created on 01 23 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var immutable_1 = require("immutable");

var moment = require("moment");

var ResultSeverity_1 = require("../../core/model/errors/ResultSeverity");

var ValidationResultFlag_1 = require("../../core/model/errors/ValidationResultFlag");

var ValidationResultObject_1 = require("../../core/model/errors/ValidationResultObject");

var utils_1 = require("../../core/utils");

var NotificationState_1 = require("./NotificationState");
/**
 * @author Jaroslav Sevcik
 * @author JMt
 * @author Tomas Leity
 */


var Notification =
/*#__PURE__*/
function (_ValidationResultObje) {
  _inherits(Notification, _ValidationResultObje);

  /**
   * @param id the internal id
   * @param severity the action severity
   * @param messageKey localization key for message (should be mandatory)
   * @param messageVariables list of variables values used to populate message.
   * @param userMessage optional localized message to be displayed for a user, can be constructed within both backend and frontend.
   * @param entityId optional identifier of an instance/entity related to result object.
   * @param flags
   * @param userId id of a user to display the notification to
   * @param type title specifying a concrete notification
   * @param eventDate date and time of an event the notification is about
   * @param group logical group of notifications
   * @param state unread, read, deleted etc.
   * @param lastChange date of the last state change
   * @param dataMap
   * @param documentType
   * @param document
   */
  function Notification(id, severity, messageKey, messageVariables, userMessage, entityId) {
    var _this;

    var flags = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : ValidationResultFlag_1.ValidationResultFlag.EMPTY_SET;
    var userId = arguments.length > 7 ? arguments[7] : undefined;
    var type = arguments.length > 8 ? arguments[8] : undefined;
    var eventDate = arguments.length > 9 ? arguments[9] : undefined;
    var group = arguments.length > 10 ? arguments[10] : undefined;
    var state = arguments.length > 11 ? arguments[11] : undefined;
    var lastChange = arguments.length > 12 ? arguments[12] : undefined;
    var dataMap = arguments.length > 13 && arguments[13] !== undefined ? arguments[13] : null;
    var documentType = arguments.length > 14 && arguments[14] !== undefined ? arguments[14] : null;
    var document = arguments.length > 15 && arguments[15] !== undefined ? arguments[15] : null;

    _classCallCheck(this, Notification);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Notification).call(this, severity, messageKey, messageVariables, userMessage, entityId, flags));
    _this.id = id;
    _this.severity = severity;
    _this.messageKey = messageKey;
    _this.messageVariables = messageVariables;
    _this.userMessage = userMessage;
    _this.entityId = entityId;
    _this.flags = flags;
    _this.userId = userId;
    _this.type = type;
    _this.eventDate = eventDate;
    _this.group = group;
    _this.state = state;
    _this.lastChange = lastChange;
    _this.dataMap = dataMap;
    _this.documentType = documentType;
    _this.document = document;
    return _this;
  }
  /**
   * Creates basic notification structure
   *
   * @param values Required notification values to set
   */


  _createClass(Notification, null, [{
    key: "createNotification",
    value: function createNotification(values) {
      return new Notification(utils_1.Utils.VOID_ID, ResultSeverity_1.ResultSeverity.Info, values.name, immutable_1.List.of(), null, values.entityId, ValidationResultFlag_1.ValidationResultFlag.EMPTY_SET, utils_1.Utils.VOID_ID, values.name, moment(), null, NotificationState_1.NotificationState.unread, null, null, null, null);
    }
  }]);

  return Notification;
}(ValidationResultObject_1.ValidationResultObject);

exports.Notification = Notification;